import { LanguageType } from "@/enums/enums";
import { GetLanguageType } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import { AssetModel, AssetTemplateModel } from "@/model/asset/assetModel";
import {
  AssetDepreciationTableModel,
  AssetTableModel,
  AssetTemplateTableModel,
  AssetUnitTableModel,
} from "@/model/asset/assetTableModel";
import { FileModel } from "@/model/file/fileModel";
export function ConvertToAssetTemplateTable(tableList: any): Array<AssetTemplateTableModel> {
  const assetTemplateTableList: Array<AssetTemplateTableModel> = [];
  if (tableList && tableList.length > 0) {
    for (const table of tableList) {
      const assetTemplateTable: AssetTemplateTableModel = {
        id: table.id,
        code: table.code,
        nameTh: table.nameTh,
        nameEn: table.nameEn,
        nameLocale: GetLanguageType() == LanguageType.En ? table.nameEn : table.nameTh,
        totalAssetTemplate: table.totalAssetTemplate,
        totalCost: table.totalCost,
        totalDepreciation: table.totalDepreciation,
        totalBookValue: table.totalBookValue,
      };
      assetTemplateTableList.push(assetTemplateTable);
    }
  }
  return assetTemplateTableList;
}
export function ConvertToAssetUnitTable(tableList: any): Array<AssetUnitTableModel> {
  const assetUnitTableList: Array<AssetUnitTableModel> = [];
  if (tableList && tableList.length > 0) {
    for (const table of tableList) {
      const assetUnitTable: AssetUnitTableModel = {
        id: table.id,
        unitCode: table.unitCode,
        name: table.name,
        nameTh: table.nameTh,
        nameEng: table.nameEng,
        isMain: table.isMain,
        isDeleted: table.isDeleted,
        isCanDelete: table.isCanDelete,
      };
      assetUnitTableList.push(assetUnitTable);
    }
  }
  return assetUnitTableList;
}
export function ConvertToAssetTable(tableList: any): Array<AssetTableModel> {
  const assetTableList: Array<AssetTableModel> = [];
  if (tableList && tableList.length > 0) {
    for (const table of tableList) {
      const assetTable: AssetTableModel = {
        assetId: table.assetId,
        uniqueId: table.uniqueId,
        purchaseAssetNumber: table.purchaseAssetNumber,
        purchaseAssetId: table.purchaseAssetId,
        purchaseDate: table.purchaseDate,
        totalCost: table.totalCost,
        totalDepreciation: table.totalDepreciation,
        totalBookValue: table.totalBookValue,
        totalUsedMonth: table.totalUsedMonth,
        totalUsedYear: table.totalUsedYear,
        isStopAssetDepreciation: table.isStopAssetDepreciation,
        saleAssetTransactionId: table.saleAssetTransactionId,
        saleAssetTransactionType: table.saleAssetTransactionType,
      };
      assetTableList.push(assetTable);
    }
  }
  return assetTableList;
}
export function ConvertToAssetDepreciationTable(tableList: any): Array<AssetDepreciationTableModel> {
  const assetDepreciationTableList: Array<AssetDepreciationTableModel> = [];
  if (tableList && tableList.length > 0) {
    for (const table of tableList) {
      const assetDepreciationTable: AssetDepreciationTableModel = {
        sequenceNumber: table.sequenceNumber,
        date: table.date,
        journalNumber: table.journalNumber,
        id: table.id,
        isDeleted: table.isDeleted,
        isDepreciation: table.isDepreciation,
        depreciationAmount: table.depreciationAmount,
        journalId: table.journalId,
        remainAmount: table.remainAmount,
        status: table.status,
      };
      assetDepreciationTableList.push(assetDepreciationTable);
    }
  }
  return assetDepreciationTableList;
}
export function ConvertToAssetDetail(detail: any): AssetModel {
  return {
    id: detail.id,
    assetTemplateId: detail.assetTemplateId,
    purchaseAssetNumber: detail.purchaseAssetNumber,
    uniqueId: detail.uniqueId,
    purchaseDate: detail.purchaseDate,
    purchaseCost: detail.purchaseCost,
    serialNumber: detail.serialNumber,
    usefulLife: detail.usefulLife,
    depreciateDate: detail.depreciateDate,
    atPurchaseDepreciatedAmount: detail.atPurchaseDepreciatedAmount,
    carryingDepreciatedAmount: detail.carryingDepreciatedAmount,
    depreciationPerDay: detail.depreciationPerDay,
    currentBookValue: detail.currentBookValue,
    accumulatedDepreciate: detail.accumulatedDepreciate,
    depreciationAllDays: detail.depreciationAllDays,
    depreciateCalculateEndDate: detail.depreciateCalculateEndDate,
    depreciateCalculateLatestDate: detail.depreciateCalculateLatestDate,
    invoiceId: detail.invoiceId,
    invoiceProductId: detail.invoiceProductId,
    depreciateAccountId: detail.depreciateAccountId,
    accumulatedDepreciateAccountId: detail.accumulatedDepreciateAccountId,
    scrapAmount: detail.scrapAmount,
    isCarrying: detail.isCarrying,
    stopAssetDepreciationDate: detail.stopAssetDepreciationDate,
    qrCode: detail.qrCode,
    isDeleted: detail.isDeleted,
    isStopAssetDepreciation: detail.isStopAssetDepreciation,
    saleAssetCost: detail.saleAssetCost,
    saleAssetDate: detail.saleAssetDate,
    saleAssetTransactionId: detail.saleAssetTransactionId,
    saleAssetTransactionType: detail.saleAssetTransactionType,
    stopAssetDepreciationType: detail.stopAssetDepreciationType,
    totalUsedYear: detail.totalUsedYear,
    totalUsedMonth: detail.totalUsedMonth,
    saleAssetTransactionNumber: detail.saleAssetTransactionNumber,
    location: detail.location,
    description: detail.description,
  };
}
export function ConvertToAssetTemplateDetail(detail: any): AssetTemplateModel {
  const assetTemplate = {
    id: detail.id,
    nameTh: detail.nameTh,
    nameEn: detail.nameEn,
    assetCategoryId: detail.assetCategoryId,
    assetSubcategoryId: detail.assetSubcategoryId,
    assetUnitId: detail.assetUnitId,
    accountDepreciationMethodId: detail.accountDepreciationMethodId,
    assetTemplateCode: detail.assetTemplateCode,
    description: detail.description,
    remark: detail.remark,
    dropboxLink: detail.dropboxLink,
    imagePath: detail.imagePath,
    assetAccountId: detail.assetAccountId,
    depreciationAccountId: detail.depreciationAccountId,
    accumulatedDepreciationAccountId: detail.accumulatedDepreciationAccountId,
    accountUsefullYear: detail.accountUsefullYear,
    accountScrapAmount: detail.accountScrapAmount,
    accountScrapTypeId: detail.accountScrapTypeId,
    accountScrapVal: detail.accountScrapVal,
    accountValPurchaseAmount: detail.accountValPurchaseAmount,
    accountValPurchaseTypeId: detail.accountValPurchaseTypeId,
    accountValPurchase: detail.accountValPurchase,
    barcode: detail.barcode,
    isDeleted: detail.isDeleted,
    imageList: [] as Array<FileModel>,
  };

  if (detail.imageList && detail.imageList.length > 0) {
    detail.imageList.forEach((image: any) => {
      if (image.fileName) {
        assetTemplate.imageList.push({
          fileName: image.fileName,
          fileType: image.fileType,
          id: image.id,
          isSeleted: image.isSeleted,
          rawString: image.rawString,
          fileUrl: process.env.VUE_APP_PeakBlobStorage + "peakengine" + image.fileUrl,
        });
      }
    });
  }

  return assetTemplate;
}

export function ConvertToAssetTemplateList(_assetList: any) {
  const assetList: any = [];
  _assetList.forEach((_asset: any) => {
    const asset = {
      id: _asset.id,
      code: _asset.code,
      nameEn: _asset.nameEn,
      nameTh: _asset.nameTh,
      name: i18n.locale == "th" ? _asset.nameTh : _asset.nameEn,
      accountScrapAmount: _asset.scarpAmount,
      accountScrapTypeId: _asset.scrapType,
      accountScrapVal: _asset.scrapVal,
      accountValPurchase: _asset.accountValPurchase,
      accountValPurchaseAmount: _asset.accountValPurchaseAmount,
      accountValPurchaseTypeId: _asset.accountValPurchaseTypeId,
      assetAccountId: _asset.assetAccountId,
      accountDepreciationMethodId: _asset.accountDepreciationMethodId,
    };
    assetList.push(asset);
  });

  return assetList;
}
